import React from 'react';

export default class NetWorkErrorDateTimeRender extends React.Component
{
	render()
	{
        let time = this.props.value;
        let _date = new Date();
        _date.setTime(time);

        var y=_date.getFullYear();
        var m=_date.getMonth()+1;
        var d=_date.getDate();
        var hours = _date.getHours();
        var minutes = _date.getMinutes();
        var seconds =_date.getSeconds();
        let _value = y+"年"+m+"月"+d+"日"+" "+hours+":"+minutes+":"+seconds;

		return <div style={{width:"100%",height:"100%",paddingLeft:"2px",paddingTop:"3px"}}>{_value}</div>
	}
}


// WEBPACK FOOTER //
// ./src/networkerror/NetWorkErrorDateTimeRender.js